import { Modal, Grid } from '@simplywallst/ui-core';

import { getStaticUrl, useCloudflareImage } from '@/hooks/useCloudflareImage';

import { Image, ContentContainer } from './styled';

type Props = { onClose: () => void };

const WatchlistEducationModal = ({ onClose }: Props) => {
  const eventsImg = useCloudflareImage({
    src: getStaticUrl('watchlist/events.png'),
    width: 200,
    height: 114,
    fit: 'cover',
  });
  const emailImage = useCloudflareImage({
    src: getStaticUrl('watchlist/email.png'),
    width: 200,
    height: 114,
    fit: 'cover',
  });
  const fairValueImage = useCloudflareImage({
    src: getStaticUrl('watchlist/fair-value.png'),
    width: 200,
    height: 114,
    fit: 'cover',
  });

  return (
    <Modal title="Setting up a Watchlist" onClose={onClose} primaryLabel="Okay">
      <ContentContainer>
        <p>
          To help you experience the benefits of our Watchlist, we’ve added the
          first companies you’ve viewed. Our Watchlist is designed to help you
          monitor the companies you are interested in. In particular:
        </p>
        <Grid
          gap="10px"
          templateRows="repeat(3, 1fr)"
          templateColumns="repeat(2, 1fr)"
          templateColumnsMd="repeat(3, 1fr)"
          templateRowsMd="repeat(2, auto)"
        >
          <Grid>
            <Image alt="Keep track with events" src={eventsImg} />
          </Grid>
          <Grid rowMd="2">
            <strong>
              Keep track of recent events and changes in their fundamentals.
            </strong>
          </Grid>
          <Grid>
            <Image alt="Receive notifications" src={emailImage} />
          </Grid>
          <Grid rowMd="2">
            <strong>
              Receive email or push notifications for their most important
              updates.
            </strong>
          </Grid>
          <Grid>
            <Image alt="Set a fair value" src={fairValueImage} />
          </Grid>
          <Grid>
            <strong>
              Set a Fair Value to help you decide when is the right time to buy
              a company.
            </strong>
          </Grid>
        </Grid>
        <p>
          Finally, if you want to learn more about how our Watchlist works, you
          can{' '}
          <a href="https://www.youtube.com/watch?v=3j7VYbCsZcU">
            watch this video tutorial
          </a>
          .
        </p>
      </ContentContainer>
    </Modal>
  );
};

export default WatchlistEducationModal;
